import {useEffect} from 'react';

/**
 * La cabecera de lo público mientras está montado:
 *  - el título de la pestaña: el navegador de WhatsApp lo muestra en su barra, y «Dashbo» a secas no
 *    le dice nada a un vendedor que nunca oyó el nombre;
 *  - `referrer: no-referrer`: la URL lleva el token del link (`/conectar/<token>`) o el `code` y el
 *    `state` de Mercado Libre, y no tiene que salir en el `Referer` de nada (Mercado Libre, el logo de
 *    la agencia, la API). El default del navegador ya manda sólo el origen hacia otro dominio; esto lo
 *    deja en nada, también para lo del mismo origen.
 * Al salir se devuelve lo que había.
 */
export function usePublicPageHead(title) {
    useEffect(() => {
        const previous = document.title;
        document.title = title;
        return () => { document.title = previous; };
    }, [title]);

    useEffect(() => {
        let meta = document.querySelector('meta[name="referrer"]');
        const previous = meta ? meta.getAttribute('content') : null;
        if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute('name', 'referrer');
            document.head.appendChild(meta);
        }
        meta.setAttribute('content', 'no-referrer');
        return () => {
            if (previous === null) meta.remove();
            else meta.setAttribute('content', previous);
        };
    }, []);
}
